import React from 'react';

const BrochureContext = React.createContext({
	brochure: null,
});

export default BrochureContext
